interface Factor {
  type: 'positive' | 'negative';
  title: string;
  checklist: string[];
}

const Factors: Factor[] = [
  {
    type: 'positive',
    title: 'Faktorer som kan påverka försäljningspriset positivt kan vara:',
    checklist: [
      'Om din bil har någon värdehöjande utrustning som vi inte kan se än så länge, exempelvis eftermonterad dragkrok eller nya fälgar.',
      'Om din bil är i väldigt bra skick och du har tagit extra väl hand om den.',
      'Om det just nu är stor efterfrågan på din modell.',
    ],
  },
  {
    type: 'negative',
    title: 'Faktorer som kan påverka försäljningspriset negativt kan vara:',
    checklist: [
      'Om det finns skador eller skavanker som gör att vi behöver göra reparationer innan vidareförsäljning.',
      'Om det är något i din bils historik som inte framkommer förrän vi kollat på bilen, exempelvis om det saknas servicestämplar.',
      'Om det finns många liknande bilar till salu just nu.',
    ],
  },
];

const FactorsAffectingPrice = `
  <section class="waykevaluation-page-section" aria-label="Faktorer som kan påverka försäljningspriset">
    ${Factors.map(
      (factor) => `
      <div class="waykevaluation-stack waykevaluation-stack--4">
        <div class="waykevaluation-stack waykevaluation-stack--2">
          <div class="waykevaluation-content">
            <p class="waykevaluation-content__p waykevaluation-text waykevaluation-text--font-medium">${
              factor.title
            }</p>
          </div>
        </div>
        <div class="waykevaluation-stack waykevaluation-stack--2">
          <ul class="waykevaluation-checklist waykevaluation-checklist--trend-${
            factor.type === 'positive' ? 'up' : 'down'
          }">
            ${factor.checklist
              .map((checklist) => `<li class="waykevaluation-checklist__item">${checklist}</li>`)
              .join('')}
          </ul>
        </div>
      </div>
    `
    ).join('')}
  </section>
`;

export default FactorsAffectingPrice;
